/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @deprecated Use globalThis directly instead.
 */
export const _globalThis = globalThis;
